import * as Sentry from "@sentry/angular";
import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

Sentry.init({
  dsn: "https://bd2671959997c182e616f597a8030d47@o4509520288153600.ingest.de.sentry.io/4509520295166032",
  tracesSampleRate: 1,
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1,
  _experiments: { enableLogs: true },
  integrations: [
    Sentry.browserTracingIntegration(), Sentry.replayIntegration(),
    // send console.error and console.warn calls as logs to Sentry
    Sentry.consoleLoggingIntegration({ levels: ["error", "warn"] }),
  ],
})

if (environment.production) {
  enableProdMode();
}

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.error(err));
